export default "__VITE_ASSET__kx61OWql__"